// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-fluid {
  padding-left: 0 !important;
  min-height: 100vh;
}

.date-picker > .ant-picker-input {
  padding: 1.5px 0px !important;
}

.range-picker {
  height: 34.5px !important;
}

.dark {
  color: black;
}

.salelist-saleperson-input .ant-select-selector {
  height: 34.5px !important;
}

.salelist-search-btn {
  height: 34.5px !important;
  display: flex !important;
  justify-content: center;
  align-items: center;
}

.date-picker-transaction-create,
.hr-staffs-date-picker {
  height: 34.5px !important;
}

.user-btn {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
}

.ant-dropdown-menu {
  border-radius: 10px !important;
}

/* ====== START - Overriding ====== */

.ant-layout-header {
  background-color: transparent !important;
  padding: 0 !important;
}

.ant-select-selection-placeholder {
  padding: 2px 0 !important;
  line-height: 30px !important;
}

.ant-select-show-search.ant-select:not(.ant-select-customize-input)
  .ant-select-selector {
  height: 34px !important;
}

.ant-input-lg {
  font-size: 14px;
}

.ant-input-number-lg input {
  height: 25px !important;
}

.ant-form-item-control-input-content
  .ant-select-selector
  .ant-select-selection-search
  .ant-select-selection-search-input {
  height: 32px !important;
}

.discount_type .ant-select-selector {
    height: 34px !important;
    display: flex;
    align-items: center;
}

.ant-drawer-body {
  padding: 0 !important;
}

.ant-menu-dark .ant-menu-inline.ant-menu-sub {
  background-color: transparent;
}

.ant-menu-title-content > a {
  padding: 0 !important;
}

.ant-menu-dark.ant-menu-dark:not(.ant-menu-horizontal) .ant-menu-item-selected {
  background-color: transparent !important;
}

.ant-menu-item .active {
  background-color: transparent !important;
}

.ant-layout {
  /* background-color: transparent; */
}

.totalMargin {
  margin-top: 8px !important;

}

.min-margin {
  margin-top :-25px !important;
}

.ant-layout-footer {
  padding: 24px !important;
  background-color: transparent !important;
}

.ant-menu-title-content a {
  color: inherit !important;
}

.ant-btn {
  height: 40px !important;
  line-height: 40px !important;
  padding: 0 15px !important;
  border-radius: 6px !important;
  box-shadow: 0 2px 4px rgb(0 0 0 / 7%);
}

.ant-picker {
  width: 100%;
}

.ant-input-number {
  width: 100%;
}

.ant-select {
  width: 100%;
}

.ant-input,
.ant-select-selector {
  border-radius: 5px !important;
}

.ant-input {
  padding: 5.5px 11px !important;
}

/* .ant-select-selector {
  height: auto !important;
  padding: 2px 11px !important;
} */

.ant-picker,
.ant-input-number {
  /* border: 1px solid #d9d9d9 !important; */
  border-radius: 5px !important;
  padding: 5px 11px !important;
}

.ant-form-item-control-input-content .ant-picker {
}

/* .ant-select-selection-search {
  height: 38px !important;
} */

/* .ant-select-single.ant-select-lg:not(.ant-select-customize-input):not(.ant-select-customize-input)
  .ant-select-selection-search-input {
  height: 20px !important;
} */

.ant-select-lg {
  font-size: 14px !important;
}

.ant-table {
  background-color: transparent !important;
}

.ant-input-affix-wrapper-status-error:not(
    .ant-input-affix-wrapper-disabled
  ):not(.ant-input-affix-wrapper-borderless).ant-input-affix-wrapper,
.ant-input-affix-wrapper-status-error:not(
    .ant-input-affix-wrapper-disabled
  ):not(.ant-input-affix-wrapper-borderless).ant-input-affix-wrapper:hover {
  background: transparent;
  padding: 0 !important;
}

.ant-input-affix-wrapper {
  background: transparent;
  border-radius: 5px !important;
  padding: 0 !important;
  border-color: #ff4d4f;
}

.ant-switch {
  background-color: rgba(0, 0, 0, 0.25) !important;
}

.ant-switch-checked {
  background-color: #1890ff !important;
}

.ant-input-number-affix-wrapper-lg {
  padding: 0 !important;
}

.ant-input-number-affix-wrapper {
  border-radius: 5px !important;
}

.ant-btn-danger {
  background-color: #ff4d4f !important;
}

/* ====== END - Overriding ====== */

/* ====== Responsive ====== */

/* Small devices (landscape phones, less than 768px) */
@media (max-width: 767.98px) {
}

/* Medium devices (tablets, less than 992px) */
@media (max-width: 991.98px) {
}

/* Large devices (desktops, less than 1200px) */
@media (max-width: 1199.98px) {
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/main.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC;;AAEA,qCAAqC;;AAErC;EACE,wCAAwC;EACxC,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;;;EAIE,uBAAuB;AACzB;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,mBAAmB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,0BAA0B;;AAE5B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,0BAA0B;EAC1B,6BAA6B;EAC7B,qCAAqC;AACvC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;;GAGG;;AAEH;;EAEE,0CAA0C;EAC1C,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;AACA;;AAEA;;GAEG;;AAEH;;;GAGG;;AAEH;EACE,0BAA0B;AAC5B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;;;;;;EAME,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;AACtC;;AAEA,mCAAmC;;AAEnC,6BAA6B;;AAE7B,sDAAsD;AACtD;AACA;;AAEA,8CAA8C;AAC9C;AACA;;AAEA,+CAA+C;AAC/C;AACA","sourcesContent":[".container-fluid {\n  padding-left: 0 !important;\n  min-height: 100vh;\n}\n\n.date-picker > .ant-picker-input {\n  padding: 1.5px 0px !important;\n}\n\n.range-picker {\n  height: 34.5px !important;\n}\n\n.dark {\n  color: black;\n}\n\n.salelist-saleperson-input .ant-select-selector {\n  height: 34.5px !important;\n}\n\n.salelist-search-btn {\n  height: 34.5px !important;\n  display: flex !important;\n  justify-content: center;\n  align-items: center;\n}\n\n.date-picker-transaction-create,\n.hr-staffs-date-picker {\n  height: 34.5px !important;\n}\n\n.user-btn {\n  border: none !important;\n  outline: none !important;\n  box-shadow: none !important;\n}\n\n.ant-dropdown-menu {\n  border-radius: 10px !important;\n}\n\n/* ====== START - Overriding ====== */\n\n.ant-layout-header {\n  background-color: transparent !important;\n  padding: 0 !important;\n}\n\n.ant-select-selection-placeholder {\n  padding: 2px 0 !important;\n  line-height: 30px !important;\n}\n\n.ant-select-show-search.ant-select:not(.ant-select-customize-input)\n  .ant-select-selector {\n  height: 34px !important;\n}\n\n.ant-input-lg {\n  font-size: 14px;\n}\n\n.ant-input-number-lg input {\n  height: 25px !important;\n}\n\n.ant-form-item-control-input-content\n  .ant-select-selector\n  .ant-select-selection-search\n  .ant-select-selection-search-input {\n  height: 32px !important;\n}\n\n.discount_type .ant-select-selector {\n    height: 34px !important;\n    display: flex;\n    align-items: center;\n}\n\n.ant-drawer-body {\n  padding: 0 !important;\n}\n\n.ant-menu-dark .ant-menu-inline.ant-menu-sub {\n  background-color: transparent;\n}\n\n.ant-menu-title-content > a {\n  padding: 0 !important;\n}\n\n.ant-menu-dark.ant-menu-dark:not(.ant-menu-horizontal) .ant-menu-item-selected {\n  background-color: transparent !important;\n}\n\n.ant-menu-item .active {\n  background-color: transparent !important;\n}\n\n.ant-layout {\n  /* background-color: transparent; */\n}\n\n.totalMargin {\n  margin-top: 8px !important;\n\n}\n\n.min-margin {\n  margin-top :-25px !important;\n}\n\n.ant-layout-footer {\n  padding: 24px !important;\n  background-color: transparent !important;\n}\n\n.ant-menu-title-content a {\n  color: inherit !important;\n}\n\n.ant-btn {\n  height: 40px !important;\n  line-height: 40px !important;\n  padding: 0 15px !important;\n  border-radius: 6px !important;\n  box-shadow: 0 2px 4px rgb(0 0 0 / 7%);\n}\n\n.ant-picker {\n  width: 100%;\n}\n\n.ant-input-number {\n  width: 100%;\n}\n\n.ant-select {\n  width: 100%;\n}\n\n.ant-input,\n.ant-select-selector {\n  border-radius: 5px !important;\n}\n\n.ant-input {\n  padding: 5.5px 11px !important;\n}\n\n/* .ant-select-selector {\n  height: auto !important;\n  padding: 2px 11px !important;\n} */\n\n.ant-picker,\n.ant-input-number {\n  /* border: 1px solid #d9d9d9 !important; */\n  border-radius: 5px !important;\n  padding: 5px 11px !important;\n}\n\n.ant-form-item-control-input-content .ant-picker {\n}\n\n/* .ant-select-selection-search {\n  height: 38px !important;\n} */\n\n/* .ant-select-single.ant-select-lg:not(.ant-select-customize-input):not(.ant-select-customize-input)\n  .ant-select-selection-search-input {\n  height: 20px !important;\n} */\n\n.ant-select-lg {\n  font-size: 14px !important;\n}\n\n.ant-table {\n  background-color: transparent !important;\n}\n\n.ant-input-affix-wrapper-status-error:not(\n    .ant-input-affix-wrapper-disabled\n  ):not(.ant-input-affix-wrapper-borderless).ant-input-affix-wrapper,\n.ant-input-affix-wrapper-status-error:not(\n    .ant-input-affix-wrapper-disabled\n  ):not(.ant-input-affix-wrapper-borderless).ant-input-affix-wrapper:hover {\n  background: transparent;\n  padding: 0 !important;\n}\n\n.ant-input-affix-wrapper {\n  background: transparent;\n  border-radius: 5px !important;\n  padding: 0 !important;\n  border-color: #ff4d4f;\n}\n\n.ant-switch {\n  background-color: rgba(0, 0, 0, 0.25) !important;\n}\n\n.ant-switch-checked {\n  background-color: #1890ff !important;\n}\n\n.ant-input-number-affix-wrapper-lg {\n  padding: 0 !important;\n}\n\n.ant-input-number-affix-wrapper {\n  border-radius: 5px !important;\n}\n\n.ant-btn-danger {\n  background-color: #ff4d4f !important;\n}\n\n/* ====== END - Overriding ====== */\n\n/* ====== Responsive ====== */\n\n/* Small devices (landscape phones, less than 768px) */\n@media (max-width: 767.98px) {\n}\n\n/* Medium devices (tablets, less than 992px) */\n@media (max-width: 991.98px) {\n}\n\n/* Large devices (desktops, less than 1200px) */\n@media (max-width: 1199.98px) {\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
